import { render, staticRenderFns } from "./CreateProjectTaskModal.vue?vue&type=template&id=6ac2a3ec&"
import script from "./CreateProjectTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports